module.exports = __webpack_public_path__ + "img/nt56-02-80-1-asm.prt.6e86eaa1.jpg";